"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.humanize = void 0;
const humanize_type_1 = require("./humanize-type");
const humanize_value_1 = require("./humanize-value");
const humanize_values_1 = require("./humanize-values");
__exportStar(require("./options"), exports);
/**
 * Convert any value to a short, human-readable string
 */
exports.humanize = humanize_value_1.humanizeValue;
exports.humanize.type = humanize_type_1.humanizeType;
exports.humanize.class = humanize_type_1.humanizeClass;
exports.humanize.function = humanize_type_1.humanizeFunction;
exports.humanize.values = humanize_values_1.humanizeValues;
exports.humanize.list = humanize_values_1.humanizeList;
// Export `humanize` as the default export
exports.default = exports.humanize;
// CommonJS default export hack
/* eslint-env commonjs */
if (typeof module === "object" && typeof module.exports === "object") {
    module.exports = Object.assign(module.exports.default, module.exports);
}
//# sourceMappingURL=index.js.map